import { v4 } from "uuid";
import { SeatGroupFactory, FabricSeatGroup } from "./seatGroup.factory";
import { TextFactory } from "./text.factory";
import { IconFactory } from "./icon.factory";
import { SeatShapeFactory } from "./seatShape.factory";

export interface CreateSeatParams {
  left: number;
  top: number;
  rowSeatSize: number;
  defaultSeatColor: string;
  editable?: boolean;
  isPreview?: boolean;
  container?: string;
  objectOption?: any;
  seatGroupId?: string;
  seatId?: string;
  iconSvgString?: string;
  category?: Category;
  sectionLabel?: string;
  tableLabel?: string;
  rowLabel?: string;
}

export interface Category {
    key: number,
    color: string,
    name: string
}

export class SeatFactory {
  static async create({
    left,
    top,
    rowSeatSize,
    defaultSeatColor,
    editable = true,
    isPreview = false,
    container,
    objectOption,
    seatGroupId = v4(),
    seatId = v4(),
    iconSvgString,
    category,
    sectionLabel = "",
    tableLabel = "",
    rowLabel = ""
  }: CreateSeatParams): Promise<FabricSeatGroup> {

    const seatGroup = SeatGroupFactory.create({
      left,
      top,
      editable,
      id: seatGroupId,
      category,
      sectionLabel,
      tableLabel,
      rowLabel
    });
    const seat = SeatShapeFactory.createSeatShape({
      left,
      top,
      rowSeatSize,
      defaultSeatColor,
      editable,
      isPreview,
      id: seatId,
      container,
      objectOption,
    });

    const text = TextFactory.create({
      left,
      top,
      fontSize: rowSeatSize - 5,
      editable,
    });

    seatGroup.addWithUpdate(seat);
    seatGroup.addWithUpdate(text);

    if(iconSvgString){
      const icon = await IconFactory.create({
        left,
        top,
        rowSeatSize,
        editable,
        svgString: iconSvgString,
      });
      seatGroup.addWithUpdate(icon);
    }
    seatGroup.setCoords();

    return seatGroup;
  }
}